import SearchComponent from '../base/search-component.ts';
import type { Impresa } from '@/types/entities/impresa.ts';

interface RisultatoRicerca {
  risultati: Impresa[];
  count: number;
}

export class RicercaImprese extends SearchComponent<RisultatoRicerca> {
  static override componentName = 'wc-ricerca-imprese';

  protected override get templateId() { return 'ricerca-imprese'; }
  protected override get resultsTemplateId() { return 'ricerca-imprese-risultati'; }

  protected override fetchResults(query: string) {
    return this.api.imprese.cerca(query);
  }

  protected override mapResultsData(data: RisultatoRicerca) {
    return { imprese: data.risultati, count: data.count };
  }

  protected override onReady(): void {
    const basePath = this.attributeString('detail-path', '/imprese');

    this.delegate.on<MouseEvent>('click', '[data-action="dettaglio"]', (e) => {
      const id = (e.target as HTMLElement).dataset.id;
      if (id) window.location.href = `${basePath}/${id}`;
    });
  }
}
